const { default: styled } = require('styled-components')

const PromptFreqModalContainer = styled.div`
  .info-row {
    margin-bottom: 12px;
    .info-label {
      font-size: 14px;
    }
    .frequency {
      display: flex;
      align-items: center;
    }
  }
  .save-section {
    display: flex;
    justify-content: flex-end;
    .btn-save-info {
      margin-top: 12px;
    }
  }
  .e-input-group-icon {
    display: none;
  }

  .e-input {
    display: block;
    width: 50%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.15rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }

  .actions {
    justify-content: flex-start;
    padding-bottom: 2rem;
  }
`
export default PromptFreqModalContainer
